import { render, staticRenderFns } from "./branchDialog.vue?vue&type=template&id=200b2165&scoped=true"
import script from "./branchDialog.vue?vue&type=script&lang=js"
export * from "./branchDialog.vue?vue&type=script&lang=js"
import style0 from "./branchDialog.vue?vue&type=style&index=0&id=200b2165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b2165",
  null
  
)

export default component.exports